<template>
  <main>
    <PageIntro
      :heading="'Activate Your Digital Account'"
      :body="'<p>Your Digital Account has been successfully created. Now, to activate it and get started, please check your inbox for an email from us. Inside, you\'ll find a verification link; simply click it to confirm your registration.</p>'" />
    <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>
    
    <v-layout row align-center mx-1>
              <router-link to="/send-confirm-code" class="text-button resend-link">Resend verification link</router-link>
              <v-spacer />
            </v-layout>
      </v-flex></v-layout></v-container>
    <FooterShout :type="'register'"/>
  </main>
</template>

<script>
  import PageIntro from '@/components/PageIntro'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      PageIntro,
      FooterShout
    }
  }
</script>
<style lang="scss" scoped>
@import "@/css/global.scss";

.resend-link{

 margin-bottom: 30px;
 
}
</style>
